import { Reducer, combineReducers } from 'redux'
import { CourseRecomUIState, CourseRecomActionTypes } from './types'
import { ICourseRecom } from '../interface'

// Type-safe initialState!
const initialState: CourseRecomUIState = {
    errors: undefined,
    loading: false,
    totDoc:0
}

const ui: Reducer<CourseRecomUIState> = (state = initialState, action) => {
    switch (action.type) {

        case CourseRecomActionTypes.FETCH_REQUEST: {
            return { ...state, loading: true}
        }
        case CourseRecomActionTypes.FETCH_SUCCESS: {
            return { ...state, loading: false, totDoc: action.payload.totalDoc }
        }
        case CourseRecomActionTypes.FETCH_ERROR: {
            return { ...state, loading: false, errors: action.payload.error }
        }
        case CourseRecomActionTypes.CLEAR_SELECTED: {

            return { ...state, selected: undefined };
        }
        case CourseRecomActionTypes.SELECT: {
            return { ...state, loading: true, selected: action.payload };
        }
        case CourseRecomActionTypes.SELECTED: {
            return { ...state, loading: false };
        }
        default: {
            return state
        }
    }
}


const byId: Reducer<{}> = (state = {}, action) => {

    switch (action.type) {
        case CourseRecomActionTypes.FETCH_SUCCESS: {

            // console.log("byid : " + state) ;
            // var _temp: any = {};
            // action.payload.forEach((item: Course) => {
            //     _temp[item.id] = item;
            // });
            // return { ...state, ..._temp };

            // Check before combine
            // const currentStateList:any = {...state};
            // var _temp: any = {};
            // action.payload.forEach((item: Course) => {
            //     if(currentStateList[item.id] === undefined)
            //     {
            //         _temp[item.id] = item;
            //         //results.push(item.id);
            //     }
            // });
            //return { ...state, ..._temp };

            // Return new result set
            var _temp: any = {};
            if (action.payload.isSuccess && action.payload.totalDoc > 0){  
                if (action.payload.offset == 0){ 
                    // Reset initial search
                    action.payload.doc.forEach((item: ICourseRecom) => {
                        _temp[item.courseId] = item;
                    });
                    return _temp;
                }
                else
                {
                    // Combine if load more
                    const currentStateList:any = {...state};
                    action.payload.doc.forEach((item: ICourseRecom) => {
                        if(currentStateList[item.id] === undefined)
                        {
                            _temp[item.courseId] = item;
                            //results.push(item.id);
                        }
                    });
                    return { ...state, ..._temp };
                }
            }else{
                return _temp;
            }
        }
        case CourseRecomActionTypes.ADD_SUCCESS:
        case CourseRecomActionTypes.EDIT_SUCCESS: {
            return {
                ...state, [action.payload.doc.id]: action.payload.doc
            }
        }
        default: {
            return state
        }
    }
}

//const allIds: Reducer<number[]> = (state = [], action) => {
const allIds: Reducer<string[]> = (state = [], action) => {
    // console.log("Action Payload:" + action.payload);
    switch (action.type) {
        case CourseRecomActionTypes.FETCH_SUCCESS: {

            // (1) This will keed append even though same id exists
            //return state.concat(...action.payload.map((item: Course) => item.id));

            // (2) Check if result exists then only combine
            // const results =[...state];
            // action.payload.forEach((item: Course) => {
            //     if(results.some((s)=>s === item.id)===false)
            //     {
            //         results.push(item.id);
            //     }
            // });
            // return results;

            // (3) Return new result only
            // var results:any =[];
            // if (action.payload.isSuccess && action.payload.totalDoc > 0){  
            //     results = action.payload.doc.map((item: Course) => item.id);
            //     console.log(results);
            // }

            // (4) Return new result for initial search, load more append
            
            if (action.payload.isSuccess && action.payload.totalDoc > 0){  
                if (action.payload.offset ==0){
                    var results:any =[];
                    results = action.payload.doc.map((item: ICourseRecom) => item.courseId);
                    return results;
                }else{
                    const results =[...state];
                    action.payload.doc.forEach((item: ICourseRecom) => {
                        if(results.some((s)=>s === item.courseId)===false)
                        {
                            results.push(item.courseId);
                        }
                    });
                    return results;
                }
                //console.log(results);
            }else{
                var results:any =[];
                return results;
            }
        }
        case CourseRecomActionTypes.ADD_SUCCESS: {
            return [
                ...state, action.payload.doc.id
            ]
        }
        default: {
            return state
        }
    }
}
//
const byCategory: Reducer<{}> = (state = {}, action) => {
    switch (action.type) {
        case CourseRecomActionTypes.FETCH_SUCCESS: {
            if (action.payload.isSuccess && action.payload.totalDoc > 0){  
                const result:any[] = action.payload.doc.reduce(function (r:any, a:any) {
                    r[a.Category] = r[a.Category] || [];
                    r[a.Category].push(a.id);
                    return r;
                }, Object.create(null));
                return result;
            }
            else{
                const result:any[] = [];
                return result;
            }
        }
        case CourseRecomActionTypes.ADD_SUCCESS: {
            const result:any = {...state};
            result[action.payload.doc.Category].push(action.payload.doc.id)
            
            return result;
        }
        default: {
            return state
        }
    }
}

const Category: Reducer<string[]> = (state = [], action) => {
    switch (action.type) {
        case CourseRecomActionTypes.FETCH_SUCCESS:
        case CourseRecomActionTypes.ADD_SUCCESS:
        {
            const results =[...state];
            
            if (action.payload.isSuccess && action.payload.totalDoc > 0){  
                action.payload.doc.forEach((item: ICourseRecom) => {
                    if(results.some((s)=>s === item.Category)===false)
                    {
                        results.push(item.Category);
                    }
                });
            }
            return results;
        }
        default: {
            return state
        }
    }
}


// Instead of using default export, we use named exports. That way we can group these exports
// inside the `index.js` folder.
const CourseRecomReducer = combineReducers({
    ui,
    byId,
    allIds,
    byCategory,
    Category
})
export default CourseRecomReducer
